import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { useTranslation } from 'react-i18next';
import BarWithElements from '../../components/BarWithElements';
import FacebookLogo from '../../components/FacebokLogo';
import LinkedInLogo from '../../components/LinkedInLogo';
import MaczekSVG from './BarWithMaczek/MaczekSVG';


const Wrapper = styled.div`
  margin: 100px 0 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const StyledFacebookLogo = styled(FacebookLogo)`
  height: 50px;
  width: 50px;
  margin-left: 10px;
  
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.extraSmall}) {
    margin-left: 25px;
  } 
  
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}) {
    margin-left: 30px;
  } 
`;

const StyledLinkedInLogo = styled(LinkedInLogo)`
  height: 50px;
  width: 50px;
  margin-left: 15px;
  
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}) {
    margin-left: 20px;
  } 
`;

const Text = styled.span`
  text-transform: initial;
`;

const MaczekWrapper = styled.div`
  position: absolute;
  top: 0;
  transform: translateY(-66%);
  right: 0;
  z-index: 1;
`;

const Socials = styled.div`
  margin-top: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BarWithSocialMediaAndMaczek = () => {
  const themeContext = useContext(ThemeContext);
  const { t } = useTranslation();

  return (
    <BarWithElements
      color={themeContext.colors.lightBlue}
    >
      <MaczekWrapper>
        <MaczekSVG />
      </MaczekWrapper>
      <Wrapper>
        <Text>
          {t('visitOutSocialMedia')}
        </Text>
        <Socials>
          <StyledFacebookLogo />
          <StyledLinkedInLogo />
        </Socials>
      </Wrapper>
    </BarWithElements>
  );
};

export default BarWithSocialMediaAndMaczek;
